import styled from 'styled-components';
import { lightGrey3Color } from 'js/config/style';

export default styled.div`
  align-self: center;
  font-size: 0.9rem;
  font-weight: ${({ bold }) => (bold ? 'bold' : '500')};
  color: ${({ bold }) => (bold ? 'black' : lightGrey3Color)};
`;
